'use strict';

/* eslint no-undef: "off" */
/**
 * XPark coupon center
 */
define('xparkCouponCenter',['swiper', 'xparkHomepageApi', 'couponCard', 'appStorage', 'util', 'busEvent'], function (Swiper, xparkHomepageApi, couponCard, appStorage, Util, busEvent) {
  return {
    template: '\n      <section class="xp-coupon-center" v-if="activities.length">\n        <div class="xp-coupon-center-swiper swiper-container" ref="couponSwiper">\n          <div class="swiper-wrapper">\n            <div\n              v-for="(activity, index) in activities"\n              :key="activity.id || index"\n              class="xp-coupon-center-slide swiper-slide"\n            >\n              <div class="xp-coupon-center-card">\n                <img :src="require.toUrl(\'images/pre_launch_bg.png\')" class="xp-coupon-center-bg" alt="" />\n\n                <div class="xp-coupon-center-head">\n                  <h2 v-text="activity.title"></h2>\n                  <div class="xp-coupon-center-countdown" aria-label="Coupon countdown">\n                    <span v-text="countdownList[index].days + \'d\'"></span>\n                    <i>:</i>\n                    <span v-text="countdownList[index].hours + \'h\'"></span>\n                    <i>:</i>\n                    <span v-text="countdownList[index].minutes + \'m\'"></span>\n                  </div>\n                </div>\n\n                <div class="xp-coupon-center-banner" v-if="activity.bannerImage">\n                  <img :src="activity.bannerImage" :alt="activity.title" />\n                </div>\n\n                <div class="xp-coupon-center-list">\n                  <coupon-card\n                    v-for="coupon in activity.coupons"\n                    :key="coupon.ruleId"\n                    :class="{\'is-unavailable\': !coupon.canGet}"\n                    :amount="coupon.discountAmount"\n                    :hide-amount="coupon.hideAmount"\n                    :name="coupon.name"\n                    :desc="coupon.desc"\n                    :start-date="coupon.startDate"\n                    :end-date="coupon.endDate"\n                    :show-action="coupon.canGet"\n                    action-text="GET"\n                    @action-click="handleCouponAction(coupon)"\n                  ></coupon-card>\n                </div>\n              </div>\n            </div>\n          </div>\n          <div\n            v-if="activities.length > 1"\n            class="xp-coupon-center-pagination swiper-pagination"\n          ></div>\n        </div>\n      </section>\n    ',
    components: {
      couponCard: couponCard
    },
    data: function data() {
      return {
        activities: [],
        couponSwiper: null,
        couponSwiperTimer: null,
        countdownTimer: null,
        nowTimestamp: Date.now()
      };
    },

    computed: {
      countdownList: function countdownList() {
        var _this = this;

        return this.activities.map(function (item) {
          return _this.getCountdownData(item);
        });
      }
    },
    mounted: function mounted() {
      this.fetchCouponActivities();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.couponSwiperTimer) {
        window.clearTimeout(this.couponSwiperTimer);
      }

      if (this.couponSwiper && this.couponSwiper.destroy) {
        this.couponSwiper.destroy(true, true);
      }

      if (this.countdownTimer) {
        window.clearInterval(this.countdownTimer);
      }
    },

    methods: {
      fetchCouponActivities: function fetchCouponActivities() {
        var _this2 = this;

        xparkHomepageApi.getCouponActivities().then(function (data) {
          if (!Array.isArray(data)) {
            _this2.activities = [];
            _this2.clearCouponState();
            return;
          }

          var list = data.map(function (item) {
            return _this2.normalizeActivity(item);
          }).filter(function (item) {
            return item.enabled;
          }).sort(function (a, b) {
            return a.position - b.position;
          });

          _this2.activities = list;

          if (!list.length) {
            _this2.clearCouponState();
            return;
          }

          _this2.startCountdown();
          _this2.$nextTick(_this2.resetCouponSwiper);
        }).catch(function () {
          _this2.activities = [];
          _this2.clearCouponState();
        });
      },
      normalizeActivity: function normalizeActivity(item) {
        var _this3 = this;

        var couponList = Array.isArray(item.coupon_list) ? item.coupon_list : [];

        return {
          id: item.id || '',
          enabled: String(item.enabled) === '1',
          position: Number(item.position || 0),
          title: String(item.title || '').trim() || 'COUPON CENTER',
          bannerImage: item.banner_image || '',
          startAt: item.start_at || '',
          endAt: item.end_at || '',
          coupons: couponList.map(function (coupon) {
            return _this3.normalizeCoupon(coupon);
          }).filter(function (coupon) {
            return coupon.active;
          }).sort(function (a, b) {
            return a.position - b.position;
          })
        };
      },
      normalizeCoupon: function normalizeCoupon(item) {
        var discountAmount = item.amount !== undefined && item.amount !== null && item.amount !== '' ? item.amount : item.discount_amount;

        return {
          ruleId: item.rule_id || item.id || '',
          name: item.name || '',
          desc: item.description || '',
          startDate: item.from_date || '',
          endDate: item.to_date || '',
          position: Number(item.position || 0),
          active: String(item.is_active) !== '0',
          canGet: String(item.can_get) === '1',
          discountAmount: discountAmount,
          hideAmount: discountAmount === undefined || discountAmount === null || discountAmount === ''
        };
      },
      resetCouponSwiper: function resetCouponSwiper() {
        if (this.couponSwiperTimer) {
          window.clearTimeout(this.couponSwiperTimer);
          this.couponSwiperTimer = null;
        }

        if (this.couponSwiper && this.couponSwiper.destroy) {
          this.couponSwiper.destroy(true, true);
          this.couponSwiper = null;
        }

        this.initCouponSwiper();
      },
      clearCouponState: function clearCouponState() {
        if (this.couponSwiperTimer) {
          window.clearTimeout(this.couponSwiperTimer);
          this.couponSwiperTimer = null;
        }

        if (this.couponSwiper && this.couponSwiper.destroy) {
          this.couponSwiper.destroy(true, true);
          this.couponSwiper = null;
        }

        if (this.countdownTimer) {
          window.clearInterval(this.countdownTimer);
          this.countdownTimer = null;
        }
      },
      initCouponSwiper: function initCouponSwiper() {
        var _this4 = this;

        var container = this.$refs.couponSwiper;

        if (!container || !this.activities.length) {
          return;
        }

        this.couponSwiperTimer = window.setTimeout(function () {
          var options = {
            loop: _this4.activities.length > 1,
            loopAdditionalSlides: _this4.activities.length,
            loopedSlides: _this4.activities.length,
            observer: true,
            observeParents: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
            speed: 350
          };

          if (_this4.activities.length > 1) {
            options.pagination = {
              el: '.xp-coupon-center-pagination',
              clickable: true
            };
          }

          _this4.couponSwiper = new Swiper(container, options);
        }, 20);
      },
      startCountdown: function startCountdown() {
        var _this5 = this;

        this.nowTimestamp = Date.now();

        if (this.countdownTimer) {
          window.clearInterval(this.countdownTimer);
        }

        this.countdownTimer = window.setInterval(function () {
          _this5.nowTimestamp = Date.now();
        }, 60000);
      },
      getCountdownData: function getCountdownData(item) {
        var endTime = this.parseTimeValue(item && item.endAt);
        var diff = Math.max(0, endTime - this.nowTimestamp);
        var minutes = Math.floor(diff / 60000);

        return {
          days: String(Math.floor(minutes / 1440)).padStart(2, '0'),
          hours: String(Math.floor(minutes % 1440 / 60)).padStart(2, '0'),
          minutes: String(minutes % 60).padStart(2, '0')
        };
      },
      parseTimeValue: function parseTimeValue(value) {
        var timeString = String(value || '').trim();

        if (!timeString) {
          return 0;
        }

        if (/^\d+$/.test(timeString)) {
          return timeString.length <= 10 ? Number(timeString) * 1000 : Number(timeString);
        }

        return new Date(timeString.replace(/-/g, '/')).getTime() || 0;
      },
      handleCouponAction: function handleCouponAction(coupon) {
        var _this6 = this;

        if (!coupon || !coupon.ruleId || coupon.fetching) {
          return;
        }

        if (!appStorage.get('token')) {
          return Util.redirect(window.commonDataJSON && window.commonDataJSON.login_url || '/customer/account/login');
        }

        coupon.fetching = true;

        xparkHomepageApi.fetchCoupon(coupon.ruleId).then(function (resData) {
          coupon.fetching = false;
          busEvent.$emit('showPopBoxUpEvent', _this6.getFetchMessage(resData, true));
        }, function (error) {
          coupon.fetching = false;
          busEvent.$emit('showPopBoxUpEvent', _this6.getFetchMessage(error, false));
        });
      },
      getFetchMessage: function getFetchMessage(payload, isSuccess) {
        if (payload && payload.message) {
          return payload.message;
        }

        if (payload && Array.isArray(payload.tips) && payload.tips.length) {
          var firstTip = payload.tips[0];
          if (typeof firstTip === 'string') {
            return firstTip;
          }
          if (firstTip && firstTip.message) {
            return firstTip.message;
          }
        }

        return isSuccess ? 'Coupon claimed successfully' : 'Get Coupon failed.';
      }
    }
  };
});
